import { atom } from "recoil";

export const manageInvitationDataState = atom({
  key: "manageInvitationDataState",
  default: [],
});

export const hasMoreInvitationDataState = atom({
  key: "hasMoreInvitationDataState",
  default: true,
});

export const manageInvitationPageState = atom({
  key: "manageInvitationPageState",
  default: 2,
});
